import { render } from "./Assessment.vue?vue&type=template&id=5d53348b"
import script from "./Assessment.vue?vue&type=script&lang=js"
export * from "./Assessment.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__